const query = {
  state: {
    query: {
    }
  },
  mutations: {
  },
  getters: {
  }
}

export default query
